import { z } from 'zod';
/**
 * Console roles, as Cognito groups. One definition for the backend (which authorises on them)
 * and the frontend (which only labels and navigates with them).
 */
export const RoleSchema = z.enum(['viewer', 'tester', 'approver', 'security-admin']);
/** Most privileged first. A user in several groups is treated as the highest. */
export const ROLE_PRECEDENCE = [
    'security-admin',
    'approver',
    'tester',
    'viewer',
];
/** Roles permitted to create or modify applications and engagements. `viewer` reads only. */
export const WRITE_ROLES = new Set([
    'tester',
    'approver',
    'security-admin',
]);
/**
 * Resolves the effective role from a `cognito:groups` claim, defaulting to `viewer`.
 *
 * Unrecognised groups are ignored rather than trusted, and the default is the least
 * privileged role so a misconfigured user can read but never write.
 */
export function roleFromGroups(groups) {
    const list = Array.isArray(groups)
        ? groups.filter((g) => typeof g === 'string')
        : [];
    return ROLE_PRECEDENCE.find((role) => list.includes(role)) ?? 'viewer';
}
//# sourceMappingURL=role.js.map